import { NodeType } from 'hubspot-prosemirror/pm/model';
import { EditorState } from 'hubspot-prosemirror/pm/state';
import { liftTarget } from 'hubspot-prosemirror/pm/transform';
import { NodePos } from '../../types';

export function buildBlockLiftTransaction(
  state: EditorState,
  nodeType: NodeType
) {
  const { from, to } = state.selection;
  const tr = state.tr;
  const nodeDetails: NodePos[] = [];

  tr.doc.nodesBetween(from, to, (node, pos, parent) => {
    if (parent && parent.type === nodeType) {
      nodeDetails.push({ node, pos });
      return false;
    }
    return true;
  });

  nodeDetails.forEach((npos) => {
    const mappedPosition = tr.mapping.map(npos.pos);
    const range = tr.doc
      .resolve(mappedPosition)
      .blockRange(tr.doc.resolve(mappedPosition + npos.node.nodeSize));
    const target = range && liftTarget(range);
    if (typeof target === 'number' && range) {
      tr.lift(range, target).scrollIntoView();
    }
  });

  return tr;
}
